import { appContext } from '../AppContext';

export const getCurrentUser = () => {
  const state = appContext?.store?.getState();
  const user = state?.profile?.user;
  return user;
};

export const getCurrentUserEmailAddress = () => {
  const state = appContext?.store?.getState();
  const emailAddress = state?.profile?.user?.email || state?.profile?.independentUser?.email;
  return emailAddress;
};

export const isCurrentUser = (username) => {
  const currentUser = getCurrentUser();
  return currentUser?.email === username;
};

export const getCurrentUserGroupIds = () => {
  const state = appContext?.store?.getState();
  return state?.profile?.groupIds;
};

export const isInTrial = () => {
  const state = appContext?.store?.getState();
  return state?.profile?.isInTrial;
};

export const isSSOLogin = () => {
  const state = appContext?.store?.getState();
  return state?.userInfo?.useSSO === 'true';
};

export const isSpecialAccessLogin = () => {
  const state = appContext?.store?.getState();
  return state?.userInfo?.specialAccess === 'true';
};

export const getCurrentClientId = () => {
  const state = appContext?.store?.getState();
  return state?.profile?.client?.id;
};
